import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ContactModal } from '@/components/ContactModal';
import { HeroSection } from '@/components/sections/HeroSection';
import { AboutSection } from '@/components/sections/AboutSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { SolutionsSection } from '@/components/sections/SolutionsSection';
import { WhyChooseSection } from '@/components/sections/WhyChooseSection';
import { ProcessSection } from '@/components/sections/ProcessSection';
import { CareersSection } from '@/components/sections/CareersSection';
import { ContactSection } from '@/components/sections/ContactSection';
import CareersPage from '@/pages/CareersPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';

// Main Layout Component
const Layout = ({ children }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [prefillMessage, setPrefillMessage] = useState('');

  const openContactModal = (message = '') => {
    setPrefillMessage(message);
    setIsContactModalOpen(true);
  };

  return (
    <div className="app-wrapper">
      <Header onOpenContactModal={() => openContactModal()} />
      <main className="main-content">
        {React.cloneElement(children, { 
          onOpenContactModal: openContactModal 
        })}
      </main>
      <Footer />
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)}
        prefillMessage={prefillMessage}
      />
    </div>
  );
};

// Home Page with All Sections
const HomePage = ({ onOpenContactModal }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
      }
      window.history.replaceState({}, '');
    }
  }, [location.state]);

  return (
    <div 
      data-testid="home-page"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <Helmet>
        <title>KritvaSoft | AI, Automation & Digital Transformation</title>
        <meta name="description" content="KritvaSoft provides AI-powered automation, enterprise software solutions, and digital transformation services to help businesses innovate, scale, and succeed." />
        <link rel="canonical" href="https://www.kritvasoft.com/" />
      </Helmet>
      <HeroSection onOpenContactModal={onOpenContactModal} />
      <AboutSection />
      <ServicesSection onOpenContactModal={onOpenContactModal} />
      <SolutionsSection onOpenContactModal={onOpenContactModal} />
      <WhyChooseSection />
      <ProcessSection onOpenContactModal={onOpenContactModal} />
      <CareersSection />
      <ContactSection onOpenContactModal={onOpenContactModal} />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={
              <Layout>
                <HomePage />
              </Layout>
            } 
          />
          <Route 
            path="/careers" 
            element={
              <Layout>
                <CareersPage />
              </Layout>
            } 
          />
          <Route 
            path="/privacy-policy" 
            element={
              <Layout>
                <PrivacyPolicyPage />
              </Layout>
            } 
          />
          <Route 
            path="/terms-of-service" 
            element={
              <Layout>
                <TermsOfServicePage />
              </Layout>
            } 
          />
          <Route 
            path="*" 
            element={
              <Layout>
                <HomePage />
              </Layout>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
